import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppService } from './app.service';
@Injectable({
  providedIn: 'root'
})
export class MainService {
  // baseUrl: string = "http://localhost:63315/";
  // baseUrl: string = "http://192.168.0.110:81/";
  baseUrl = 'http://192.168.0.53/iposapi/';
  reportUrl = '';
  CommonSetting: any;
  E_Commerce: any;
  appName = 'RetailPOS';
  AccessToken = '';
  private SettingsMaster: iSettingsMaster = {
    CashierId: 0, CounterId: 0, CounterOpenId: 0,
    DayOpenId: 0, LocId: 0, SessionId: 0, UniqueId: '123456', CashierName: '', CCode: 1,
    PrinterName: '',BranchId:0,SellingPriceLevelId:0
  };
  constructor(private http: HttpClient, private router: Router, private app: AppService) {
    this.baseUrl = this.app.app_Setting.BaseUrl;
    this.reportUrl = this.app.app_Setting.ReportUrl;
    this.CommonSetting = this.app.app_Setting.CommonSetting;
    this.E_Commerce = this.app.app_Setting['E-Commerce'];
  }
  public getHeader() {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.GetAccessToken()
    });
    headers.append('Content-Type', 'application/json');
    return headers;
  }
  GetCounterDetailsForLogin(body) {
    return this.http
      .post(this.baseUrl + '/services/api/v1/POS/GetCounterdetailsforLogin', body, {
        headers: this.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
    // return this.http.post(this.baseUrl + "/services/api/v1/POS/GetCounterdetailsforLogin", body, {
    //     headers: this.getHeader()
    //   })
  }
  SetAccessToken(token) {
    this.AccessToken = token;
    localStorage.setItem(this.appName + '_IsAuthenticated', 'true');
    localStorage.setItem(this.appName + '_AccessToken', token);
  }
  setLocal(locId, CounterOpenId, CashierId, CounterId, DayOpenId, SessionId, UniqueId, CashierName, PrinterName,BranchId,SellingPriceLevelId) {
    localStorage.setItem(this.appName + '_locId', locId);
    localStorage.setItem(this.appName + '_CounterOpenId', CounterOpenId);
    localStorage.setItem(this.appName + '_CashierId', CashierId);
    localStorage.setItem(this.appName + '_CounterId', CounterId);
    localStorage.setItem(this.appName + '_DayOpenId', DayOpenId);
    localStorage.setItem(this.appName + '_SessionId', SessionId);
    localStorage.setItem(this.appName + '_UniqueId', UniqueId);
    localStorage.setItem(this.appName + '_CashierName', CashierName);
    localStorage.setItem(this.appName + '_PrinterName', PrinterName);
    localStorage.setItem(this.appName + '_BranchId', BranchId);
    localStorage.setItem(this.appName + '_SellingPriceLevelId', SellingPriceLevelId);
    this.getSettings();
  }
  GetAccessToken() {
    return localStorage.getItem(this.appName + '_AccessToken');
  }
  setSettings(data: iSettingsMaster) {
    this.SettingsMaster = data;
  }
  getSettings(): iSettingsMaster {
    // this.un
    // tslint:disable-next-line: triple-equals
    if (this.SettingsMaster.LocId == 0 || this.SettingsMaster.CounterOpenId == 0) {
      this.SettingsMaster.LocId = Number(localStorage.getItem(this.appName + '_locId'));
      this.SettingsMaster.CounterOpenId = Number(localStorage.getItem(this.appName + '_CounterOpenId'));
      this.SettingsMaster.CashierId = Number(localStorage.getItem(this.appName + '_CashierId'));
      this.SettingsMaster.CounterId = Number(localStorage.getItem(this.appName + '_CounterId'));
      this.SettingsMaster.DayOpenId = Number(localStorage.getItem(this.appName + '_DayOpenId'));
      this.SettingsMaster.SessionId = Number(localStorage.getItem(this.appName + '_SessionId'));
      this.SettingsMaster.UniqueId = localStorage.getItem(this.appName + '_UniqueId');
      this.SettingsMaster.CashierName = localStorage.getItem(this.appName + '_CashierName');
      this.SettingsMaster.PrinterName = localStorage.getItem(this.appName + '_PrinterName');
      this.SettingsMaster.BranchId = Number(localStorage.getItem(this.appName + '_BranchId'));
      this.SettingsMaster.SellingPriceLevelId = Number(localStorage.getItem(this.appName + '_SellingPriceLevelId'));
      // tslint:disable-next-line: triple-equals
      if (this.SettingsMaster.LocId == 0 || this.SettingsMaster.CounterOpenId == 0) {
        this.router.navigate(['/']);
      } else {
        return this.SettingsMaster;
      }
    } else {
      if (localStorage.getItem(this.appName + '_CounterOpenId') && localStorage.getItem(this.appName + '_DayOpenId')) {
        this.SettingsMaster.CounterOpenId = Number(localStorage.getItem(this.appName + '_CounterOpenId'));
        this.SettingsMaster.DayOpenId = Number(localStorage.getItem(this.appName + '_DayOpenId'));
        this.SettingsMaster.SessionId = Number(localStorage.getItem(this.appName + '_SessionId'));
        // tslint:disable-next-line: triple-equals
        if (this.SettingsMaster.LocId == 0 || this.SettingsMaster.CounterOpenId == 0) {
          this.router.navigate(['/']);
        }
      }
      return this.SettingsMaster;
    }
  }

}
export interface IResponse {
  Success: boolean;
  data: any;
  total: number;
  error: any;
}
// tslint:disable-next-line: class-name
export interface iSettingsMaster {
  CashierId: number;
  CounterId: number;
  DayOpenId: number;
  CounterOpenId: number;
  LocId: number;
  SessionId: number;
  UniqueId: string;
  CashierName: string;
  CCode: number;
  PrinterName: string;
  BranchId:number;
  SellingPriceLevelId:number;
}
